import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../Translations';
import EnrollmentStore from '../Enrollment/Store';
import EmptyLicenseState from './EmptyLicenseState';
import ExperiencesStore from './Experiences/ExperiencesStore';
import { SkeletonListViewExperiences } from './Experiences/ListViewExperiences';
import { isEmptyCatalog } from './Experiences/ExperiencesStore/Types';
import { SkeletonProductCollections } from './Experiences/ProductCollections';
import ProductCollectionsAndExperiences from './Experiences/ProductCollectionsAndExperiences';

interface Props {
  invitationUuid: string;
  enrollmentStore: EnrollmentStore;
  experiencesStore: ExperiencesStore;
}

function ExperienceSelectionView({ invitationUuid, enrollmentStore, experiencesStore }: Props) {
  const state = experiencesStore.state;

  // Empty entitlement state: the payload has no product collections AND no
  // browsable experiences, and nothing is being searched. Under DVLP-7538 this
  // indicates the user has no active license source and no
  // `show_unlicensed_content` bypass; render an informative screen with an
  // upsell-tracking Intercom impression. An empty search result falls through
  // to the normal views, which render NoExperiences (DVLP-7990).
  if (isEmptyCatalog(state)) {
    return <EmptyLicenseState />;
  }

  switch (state.kind) {
    case 'waiting':
    case 'loading':
      return <SkeletonProductCollections />;
    case 'searching':
      return <SkeletonListViewExperiences />;
    case 'product-collections':
    case 'experiences':
    case 'product-collections-and-experiences':
      return (
        <ProductCollectionsAndExperiences
          invitationUuid={invitationUuid}
          enrollmentStore={enrollmentStore}
          experiencesStore={experiencesStore}
        />
      );
    case 'error':
      return (
        <div className="flex flex-grow flex-col items-center justify-center">
          <Typography tabIndex={0}>
            <T kind="Your request failed." />
          </Typography>
        </div>
      );
  }
}

export default observer(ExperienceSelectionView);
